// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__FzxSC","right":"styles_right__2uOwI"};